module.exports = __webpack_public_path__ + "img/404.3e4ea33.png";